import { render, staticRenderFns } from "./AdministrationNestedPage.vue?vue&type=template&id=66e61960"
import script from "./AdministrationNestedPage.vue?vue&type=script&lang=js"
export * from "./AdministrationNestedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports